import * as Yup from "yup";
import { parsePartNumber } from "./validateSupplyPartNumber";

export const partNumberStringSchema = Yup.string()
  .matches(/^\d+([+-]\d+)*$/, {
    message: "Part Number must contain only numbers separated by '+' or '-'",
    excludeEmptyString: true,
  })
  .test(
    "no-duplicates",
    "Part Number must not contain duplicate values",
    function (value) {
      if (!value) return true; // Skip empty values (already handled by required)

      const allNumbers = parsePartNumber(value);
      const uniqueNumbers = new Set(allNumbers);
      return uniqueNumbers.size === allNumbers.length;
    }
  )
  .test(
    "correct-order",
    "Part Number values must be in ascending order (e.g 1-2 NOT 2-1)",
    function (value) {
      if (!value) return true; // Skip empty values (already handled by required)

      const allNumbers = parsePartNumber(value);

      const numericValues = allNumbers.map((num) => parseInt(num, 10));

      for (let i = 1; i < numericValues.length; i++) {
        if (numericValues[i] < numericValues[i - 1]) {
          return false;
        }
      }

      return true;
    }
  )
  .test(
    "correct-order",
    "Part Number values must be greater than 0",
    function (value) {
      if (!value) return true; // Skip empty values (already handled by required)

      const allNumbers = parsePartNumber(value);

      for (let i = 0; i < allNumbers.length; i++) {
        if (allNumbers[i] < 1) return false;
      }

      return true;
    }
  )
  .required("Part Number is required");
